<template>
  <div class="welcome" :style="$store.getters['customizer/getWelcomeStyles']">
    <h2 class="welcome__salutation">
      <span class="welcome__text" :style="getTextStyles">
        {{ getSalutation }}
      </span>
    </h2>
    <h2 class="welcome__name">
      <span class="welcome__text" :style="getTextStyles">
        {{ getName }}
      </span>
    </h2>
    <div class="welcome__home-button" :style="getTextStyles">
      <RegistrationButton :is-active="true">
        {{ getBack }}
      </RegistrationButton>
    </div>
  </div>
</template>

<script>
import { keyHandler } from '@/mixins/keyHandler';
import RegistrationButton from '@/components/RegistrationButton.vue';

export default {
  components: { RegistrationButton },
  mixins: [keyHandler],
  computed: {
    getSalutation() {
      return this.$store.getters['welcome/getSalutation'];
    },
    getName() {
      return this.$store.getters['welcome/getName'];
    },
    getTextStyles() {
      return this.$store.getters['welcome/getTextStyles'];
    },
    getBack() {
      return this.$i18n('back.name');
    },
  },
  methods: {
    eventHandler(key, event) {
      this.leave();
    },
    leave() {
      this.$store.dispatch('welcome/leave');
    },
  },
};
</script>

<style scoped>
.welcome {
  width: 100%;
  height: 100%;
  padding: 0 10vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.welcome__name,
.welcome__salutation {
  font-size: 6vh;
  margin-bottom: 2vh;
}

.welcome__text {
  display: inline-block;
  padding: 0.75rem;
}

.welcome__home-button {
  border-radius: 11px;
  align-self: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/pages/Welcome.vue